import axios from "axios";
import { IMeasurementPanelPosition } from "../viewer/measurement/types";

/**
 * SC_QUICK-2187 (QU3DW-1367) — Solution 2: PATCH only the panelPosition field
 * of one measurement, instead of re-uploading the whole measurement list.
 * Mirrors the existing measurement PUT/GET calls in CalcDrawerContent.
 */
export async function patchMeasurementPanelPosition(
  serverHost: string,
  projectId: string,
  pointCloudType: string,
  measurementId: number,
  panelPosition: IMeasurementPanelPosition
): Promise<{ updateAt: string }> {
  const apiUrl = `${serverHost}/api/v1/project/${projectId}/point-cloud/${pointCloudType}/measurement/${measurementId}/panel-position`;

  const response = await axios.patch(
    apiUrl,
    { panelPosition },
    { withCredentials: true }
  );

  return response.data;
}
